function CloseButton({ onClose }) {
  return (
    <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    </button>
  );
}

export default CloseButton;
